'use strict';

const Reflux = require('@muzzylane/reflux');
const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');

const SignInActions = Reflux.createActions({
    signIn: { children: ['completed', 'failed'] },
    signInSso: { children: ['completed', 'failed'] },
    signOut: { children: ['completed', 'failed'] },
    resetStore: { children: ['completed'] },
    emulate3p: { children: ['completed', 'failed'] },
    clearEmulate3p: { children: ['completed'] },
    keepAlive: { children: ['completed'] },
    // setLtiStorage: { children: ['completed'] },
});

SignInActions.signIn.listen(function(actionId, params) {
    const self = this;
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;

    if (!params.email) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push('email');
    }

    if (!params.password) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push('password');
    }

    if (!valid) {
        this.failed(actionId, new ForgeError({ message: errorMsg, uiRefs: errorUIRefs }));
        return;
    }

    ServerRequest.makeRequest('/authoring/login', 'POST', JSON.stringify({
            email: params.email,
            password: params.password,
            expire: !params.staySignedIn,
        }))
        .then(res => self.completed(actionId, res))
        .catch(err => self.failed(actionId, err));
});


SignInActions.signInSso.listen(function(actionId, params) {
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;
    if (!params.email) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push('email');
    }

    if (!params.password) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push('password');
    }

    if (!params.ssoSpQueryObj) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
    }

    if (!valid) {
        this.failed(actionId, new ForgeError({ message: errorMsg, uiRefs: errorUIRefs }));
        return;
    }

    ServerRequest.makeRequest('/authoring/sso/login', 'POST', JSON.stringify({
            email: params.email,
            password: params.password,
            ssoSpQueryObj: params.ssoSpQueryObj,
        }))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

SignInActions.signOut.listen(function() {
    const self = this;

    ServerRequest.makeRequest('/authoring/logout', 'POST')
        .then(self.completed)
        .catch(self.failed);
});

SignInActions.resetStore.listen(function() {
    this.completed();
});

SignInActions.emulate3p.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest('/authoring/emulate/3p', 'POST', JSON.stringify({
        userId: params.userId,
        password: params.password
    }))
    .then(res => { self.completed(actionId, res); })
    .catch(err => { self.failed(actionId, err); });
});

SignInActions.clearEmulate3p.listen(function(actionId, params) {
    ServerRequest.makeRequest('/authoring/emulate/3p/logout', 'POST', JSON.stringify({}))
        .then(res => this.completed(actionId, res))
        .catch(err => this.completed(actionId, err));
});

SignInActions.keepAlive.listen(function() {
    const self = this;

    ServerRequest.makeRequest('/authoring/user/keep_alive', 'GET')
        .then(self.completed)
        .catch(self.completed);
});

//SignInActions.setLtiStorage.listen(function(actionId, params) {
//    this.completed(actionId, params);
//});

module.exports = SignInActions;